.chip {
  composes: pressable from './surface.module.css';

  position: relative;
  flex: none;
  min-width: var(--target); /* single letters (root notes, keys) are still 44 px wide (audit A2) */
  min-height: 36px;
  padding: 0 var(--s3);
  background: var(--pad);
  border: 1px solid var(--line);
  border-radius: var(--r-control);
  color: var(--ink);
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 650;
  white-space: nowrap;
}

/* Extends the hit area to 44 px without changing the look */
.chip::after {
  content: '';
  position: absolute;
  inset: -5px -2px;
}

.chip[aria-pressed='true'] {
  background: var(--ink);
  border-color: var(--ink);
  color: var(--panel);
}

.chip:disabled {
  opacity: 0.45;
  cursor: default;
}
